export default (el) => {
  if (!el) return;
  document.createRange();
  el.select();
  document.execCommand('copy');
  window.getSelection().removeAllRanges();
};
